import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import RemindersItem from 'src/components/RemindersItem';
import { OrderIcon } from 'src/components/SkladonIcon/SmallIcons';
import { ClaimType } from 'src/types/claim';

export interface TopBlockPropsType {
    data: ClaimType | null;
    idClaim: string | undefined;
    newClaim: boolean;
    disableEdit: boolean;
    loading: boolean;
    handleSave: () => boolean | Promise<boolean>;
    handleCreateOrder: () => void;
    activeTab: string;
    onChangeTab: (value: string) => void;
    permissionCreateOrder: boolean;
    showErrorLogTab: boolean;
    canEditErrorLog: boolean;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    const tabs = [
        { value: 'detail', label: translate('claimDetail.detail') },
        ...(props.showErrorLogTab ?
            [{ value: 'errorLogging', label: translate('claimDetail.errorLogging') }] :
            []),
        { value: 'history', label: translate('claimDetail.history') },
    ];

    return (
        <>
            <BodyTopBlock
                tabs={tabs}
                selectTab={!props.newClaim ? props.activeTab : undefined}
                onChangeTab={!props.newClaim ? props.onChangeTab : undefined}
                actions={[
                    {
                        icon: <OrderIcon />,
                        onClick: () => props.handleCreateOrder(),
                        tooltip: translate('claimDetail.action.createOrder'),
                        // label: translate('claimDetail.action.createOrder'),
                        variant: 'outlined',
                        hidden: props.newClaim || !props.permissionCreateOrder,
                    },
                    {
                        actionKey: 'reminders',
                        element: !props.newClaim ? <RemindersItem type="claim" idItem={props.idClaim} /> : null,
                    },
                    {
                        label: translate(props.newClaim ? 'claimDetail.action.create' : 'claimDetail.action.save'),
                        onClick: async () => {
                            await props.handleSave();
                        },
                        hidden:
                            (props.activeTab !== 'detail' && props.activeTab !== 'errorLogging') ||
                            (props.activeTab === 'errorLogging' && !props.canEditErrorLog),
                        disabled: props.loading,
                        'data-testid': 'claim-save-btn',
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
